module.exports = "<h1 style=\"margin-top: 20px\"> This is Admin Orders Page </h1>\r\n\r\n<list-order-view [order$]=\"order$\"></list-order-view> "